import React from 'react';
import styles from './TopPart.css';
import TEXTS from '@/constants/texts';

const TopPart: React.FunctionComponent = () => {
	const tryClick = (): void => {
		const inputForm: HTMLElement | null = document.getElementById('input-form');

		if (inputForm) {
			inputForm.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<div className={styles.topPart}>
			<div className={styles.textBlock}>
				<div className={styles.textContainer}>
					<div className={styles.mainText}>
						<p className={styles.text}>{TEXTS.topTitle}</p>
					</div>
					<p className={styles.description}>{TEXTS.topDescription}</p>

					<div>
						<div className={styles.button} onClick={tryClick}>
							<p className={styles.buttonText}>Попробовать</p>
						</div>
					</div>
				</div>
			</div>

			<div className={styles.imageBlock}>
				<img
					src="https://img.imgsmail.ru/static.promo/jsonld-demo/desktop.png"
					className={styles.desktopImage}
				/>
				<img
					src="https://img.imgsmail.ru/static.promo/jsonld-demo/iphone.png"
					className={styles.mobileImage}
				/>
			</div>
		</div>
	);
};

export default TopPart;
